/**
 * Format a date string or Date object for display as DD/MM/YYYY (Gregorian)
 * Handles YYYY-MM-DD, ISO 8601 strings, and Date objects
 */
export const formatDate = (input) => {
  if (!input) return '-';

  if (input instanceof Date) {
    if (isNaN(input.getTime())) return '-';
    const day = String(input.getDate()).padStart(2, '0');
    const month = String(input.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}/${input.getFullYear()}`;
  }

  // Take date part only to avoid timezone shifts (e.g. "2025-06-23T00:00:00.000Z")
  const datePart = String(input).split('T')[0];
  const parts = datePart.split('-');
  if (parts.length === 3) {
    return `${parts[2].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[0]}`;
  }

  return '-';
};

/**
 * Format a Date object as YYYY-MM-DD for API/input fields
 * Uses local date parts to avoid UTC timezone shift (Thailand UTC+7)
 */
export const formatDateForInput = (date) => {
  if (!date || isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/** Today as YYYY-MM-DD (local time) */
export const todayStr = () => formatDateForInput(new Date());

/** First day of current month as YYYY-MM-DD (local time) */
export const firstDayOfMonthStr = () => {
  const now = new Date();
  return formatDateForInput(new Date(now.getFullYear(), now.getMonth(), 1));
};

/** n days ago as YYYY-MM-DD (local time) */
export const daysAgoStr = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return formatDateForInput(d);
};

/** n months ago as YYYY-MM-DD (local time) */
export const monthsAgoStr = (n) => {
  const d = new Date();
  d.setMonth(d.getMonth() - n);
  return formatDateForInput(d);
};
